// Split a string by commas and trim spaces for domains field for the SSO Admin Modal
export const splitStringToArray = (str: string): string[] => {
    return str.split(',').map(item => item.trim());
  };
